/**
* Content Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-accordion' ).each( function() {
        $( this ).find( '.content-accordion__item-answer' ).each( function() {
          this.addEventListener( 'toggleAfter', ( event ) => {
            if ( `${window.easyToggleState.isActive( event.target )}` ) {
              if ( event.target.style.maxHeight ) {
                event.target.style.maxHeight = null;
              } else {
                event.target.style.maxHeight = event.target.scrollHeight + 12 + 'px';
              }
            }
          }, false );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
